export enum BlockCollectionTypes {
    AD_BLOCK = "ad_block",
    ACCORDION_BLOCK = "accordion_block",
    AD_LAYOUT_BLOCK = "ad_layout_block",
    HEADER_BLOCK = "header_block",
    LANDING_PAGE_SPLIT_BLOCK = "landing_page_split_block",
    PRODUCT_CATEGORIES_BLOCK = "product_categories_block",
    RITCHTEXT_BLOCK = "ritchtext_block",
    SUPPLIER_SHOWCASE_BLOCK = "supplier_showcase_block",
    BUTTON_BLOCK = "button_block",
    PARTNER_BLOCK = "partner_block",
    FUNDING_BLOCK = "funding_block",
    RESOURCE_BLOCK = "resource_block",
    CONTACT_FORM_BLOCK = "contact_form_block",
    CONFIRMATION_BLOCK = "confirmation_block",
    PACKAGE_BLOCK = "package_block",
    AD_PACKAGES_BLOCK = "ad_packages_block",
    BRONZE_SUBSCRIPTION_FORM_BLOCK = "bronze_subscription_form_block"
}
